import { Event } from '@domain/event';
import { GenericQueryOptions, useGenericQuery } from '@hooks/use-generic-query';
import { UseQueryResult } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const getEventByIdFetch = async (eventId?: string) => {
  if (!eventId) return null;
  const url = `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/events/${eventId}`;

  return request({ url, method: RequestMethod.GET });
};

// Cache times for event data
const STALE_TIME = 10 * 1000; // 10 seconds - data is fresh for this period, preventing duplicate refetches
const GC_TIME = 30 * 1000; // 30 seconds - cache persists even without active observers

export const GET_EVENT_QUERY_KEY = QUERY_KEYS.getEvent;

export const getEventQueryKey = (eventId?: string) => [QUERY_KEYS.getEvent, eventId];

export const useGetEvent = ({
  eventId,
  options,
}: {
  eventId?: string;
  options?: GenericQueryOptions<Event, RequestError>;
}): UseQueryResult<Event, RequestError> => {
  return useGenericQuery<Event, RequestError>(getEventQueryKey(eventId), () => getEventByIdFetch(eventId), {
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
    enabled: !!eventId,
    ...options,
  });
};
